import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { Page } from 'src/app/models/page.model';
import { SharedService } from 'src/app/services/shared.service';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-other-page',
  templateUrl: './other-page.component.html',
  styleUrls: ['./other-page.component.css']
})
export class OtherPageComponent implements OnInit {

  public showSpinner: boolean;

  public htmlContent: string;

  page: Page = new Page()


  constructor(
    private route: ActivatedRoute,
    private firestore: AngularFirestore,
    private sharedService:SharedService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.getPage();

    const id = 'OIiT0QezEJUsHcC3mJZU';
    this.sharedService.getBanner(id).then(result=>{
      const imageUrl = result.image.fileUrl;
      document.getElementById('bg-cover').style.backgroundImage = 'url(' + imageUrl + ')';
    })
    

  }

  getPage() {
    this.showSpinner = true
    let pageId = this.route.snapshot.params['pageId']
    const id$ = new Subject<string>()
    const queryObservable = id$.pipe(
      switchMap(id =>
        this.firestore.collection('pages').doc(id).get()
      )

    );
    // subscribe to changes
    queryObservable.subscribe(queriedItem => {
      console.log(queriedItem.data())
      var page: Page = new Page()
      Object.assign(page, queriedItem.data())
      this.titleService.setTitle(`${page.title} | CamEdu`);
      this.page = page
      this.htmlContent = this.page.description
      this.showSpinner = false

    });

    // trigger the query
    id$.next(pageId)

  }

}
